import * as React from 'react';
export default function SvgRouter() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 13.5c-.69 0-1.25.56-1.25 1.25v2.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25H6.75zM4 14.75A2.75 2.75 0 016.75 12h10.5A2.75 2.75 0 0120 14.75v2.5A2.75 2.75 0 0117.25 20H6.75A2.75 2.75 0 014 17.25v-2.5z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 16a1 1 0 112 0 1 1 0 01-2 0zM10 16a1 1 0 112 0 1 1 0 01-2 0zM12 10a.75.75 0 01.75.75v1.75a.75.75 0 01-1.5 0v-1.75A.75.75 0 0112 10zM13.768 9.232a2.5 2.5 0 00-3.536 0 .75.75 0 11-1.06-1.06 4 4 0 015.656 0 .75.75 0 01-1.06 1.06z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.89 7.11a5.5 5.5 0 00-7.78 0 .75.75 0 11-1.06-1.06 7 7 0 019.9 0 .75.75 0 01-1.06 1.06z",
    fill: "currentColor"
  }));
}